import { DefaultTheme } from 'styled-components';
import * as colors from './color';

const defaultThemeColors = {
  text: {
    body: colors.textDefault,
    heading: colors.green.darker(80),
    link: colors.green.darker(50),
  },
  button: {
    primary: colors.green.base,
    selected: colors.green.darker(50),
    hover: colors.green.darker(20),
    text: colors.textDefault,
  },
  primary: colors.green.base,
  secondary: colors.green.darker(50),
  background: colors.green.lighter(70),
  notification: colors.yellow.base,
};

const defaultThemeSizes = {
  sideMargin: {
    mobile: '24px',
    desktop: '32px',
  },
  borderRadius: {
    default: '12px',
    round: '32px',
  },
};

const defaultThemeFontFamilies = {
  body: 'var(--font-mona-sans)',
  heading: 'var(--font-youth)',
  headingBrand: 'var(--font-youth)',
};

const defaultThemeKotipizzaLogos = {
  white: '/Kotipizza_Logo.svg',
  dark: '/Kotipizza_Dark_Logo.svg',
};

const defaultThemeLoyaltyLogos = {
  white: 'https://mob.kotipizza.fi/Kuvat/logot/kotijoukot-white.svg',
  dark: 'https://mob.kotipizza.fi/Kuvat/logot/kotijoukot-dark.svg',
};

export const defaultTheme: DefaultTheme = {
  version: 'default',
  isApp: false,
  color: defaultThemeColors,
  sizes: defaultThemeSizes,
  fontFamily: defaultThemeFontFamilies,
  logo: defaultThemeKotipizzaLogos,
  loyaltyLogo: defaultThemeLoyaltyLogos,
} as const;

export const defaultAppTheme: DefaultTheme = {
  version: 'appDefault',
  // This bool is used to conditionally disable hover and focus states when we're in the app.
  // It's easier to implement this as a theme prop, so that we don't have to pass separate 'isApp' props to all kinds of styled components
  isApp: true,
  color: defaultThemeColors,
  sizes: defaultThemeSizes,
  fontFamily: defaultThemeFontFamilies,
  logo: defaultThemeKotipizzaLogos,
  loyaltyLogo: defaultThemeLoyaltyLogos,
} as const;

const themes = [defaultTheme, defaultAppTheme];

export default themes;
